import { render } from "./PropertiesPanel.vue?vue&type=template&id=7db1cdbd&scoped=true&ts=true"
import script from "./PropertiesPanel.vue?vue&type=script&lang=ts"
export * from "./PropertiesPanel.vue?vue&type=script&lang=ts"

import "./PropertiesPanel.vue?vue&type=style&index=0&id=7db1cdbd&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db1cdbd"]])

export default __exports__